var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v(" Vous ne pouvez pas créer de candidature à une bourse. Pour plus d'informations, veuillez contacter le service administratif. ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }